// DialogSetting Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import Avatar from '../../../common/common/avatar/avatar.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'

class DialogSetting extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      title: props.title,
      message: props.message,
      status: props.status,
      imageUrl: ''
    }
  }

  static get propTypes () {
    return {
      title: PropTypes.string,
      message: PropTypes.string,
      status: PropTypes.string,
      onClose: PropTypes.func,
      children: PropTypes.node,
      className: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      title: null,
      message: null,
      status: null,
      onClose: null,
      children: null,
      className: null
    }
  }

  show (title, message, imageUrl, status) {
    FabButtonManager.setVisible(false)
    if (imageUrl) {
      this.setState({ imageUrl: imageUrl })
    }
    this.setState({
      active: true,
      title: title,
      message: message,
      status: status
    })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      imageUrl: '',
      title: '',
      message: '',
      status: ''
    })

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  isActive () {
    return this.state.active
  }

  render () {
    const _className = classnames(
      'dialog-actionboard',
      {},
      `dialog-actionboard_${this.props.className}`
    )
    const _statusClassName = classnames(
      'status',
      {},
      `${this.state.status}`
    ).toLowerCase()

    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        modal
      >
        {this.state.imageUrl ? (
          <div className='itemheader'>
            <Avatar imageUrl={this.state.imageUrl} />
          </div>
        ) : null}
        <div className={_className}>
          <div className='actionboard-section'>
            <div className='actionboard-row'>
              <div className='actionboard-col'>
                <div className='msg'>{this.state.title}</div>
                <div className='title'>{this.state.message}</div>
                {this.state.message && this.state.status && (
                  <div className='split' />
                )}
                {this.state.status && (
                  <div className={_statusClassName}>{this.state.status}</div>
                )}
              </div>
            </div>
          </div>
          <div className='actionboard-footer'>{this.props.children}</div>
        </div>
      </Dialog>
    )
  }
}

export default DialogSetting
